import type { ReactElement } from 'react';

export interface DayStripProps {
  days: ReadonlyArray<{ date: string }>;
  selected: string;
  onSelect: (date: string) => void;
}

function dayOfMonth(iso: string): string {
  return iso.slice(8, 10);
}

function weekdayShort(iso: string): string {
  const d = new Date(`${iso}T00:00:00Z`);
  return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getUTCDay()] ?? '';
}

export function DayStrip({ days, selected, onSelect }: DayStripProps): ReactElement {
  return (
    <div
      className="flex gap-2 overflow-x-auto px-4 py-2"
      data-testid="planner-day-strip"
    >
      {days.map((d) => {
        const isSelected = d.date === selected;
        return (
          <button
            key={d.date}
            type="button"
            data-testid={`planner-day-${d.date}`}
            onClick={() => onSelect(d.date)}
            className="flex min-w-[64px] flex-col items-center rounded-md border px-3 py-2 text-xs"
            style={{
              borderColor: isSelected ? 'var(--accent)' : 'var(--border)',
              background: isSelected ? 'var(--accent)' : 'var(--bg-surface)',
              color: isSelected ? 'var(--bg-surface)' : 'var(--text-main)',
            }}
          >
            <span>{weekdayShort(d.date)}</span>
            <span className="text-base font-semibold">{dayOfMonth(d.date)}</span>
          </button>
        );
      })}
    </div>
  );
}